import { baseApi } from "./baseApi"
import type {
  Tournament,
  TournamentCreatePayload,
  TournamentUpdatePayload,
} from "../../types/tournaments"

export const tournamentsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTournaments: build.query<Tournament[], void>({
      query: () => "/tournaments",
      providesTags: (result) =>
        result
          ? [...result.map((t) => ({ type: "Tournament" as const, id: t.id })), { type: "Tournament", id: "LIST" }]
          : [{ type: "Tournament", id: "LIST" }],
    }),
    getTournament: build.query<Tournament, string>({
      query: (id) => `/tournaments/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Tournament", id }],
    }),
    createTournament: build.mutation<Tournament, TournamentCreatePayload>({
      query: (body) => ({ url: "/tournaments", method: "POST", body }),
      invalidatesTags: [{ type: "Tournament", id: "LIST" }],
    }),
    updateTournament: build.mutation<Tournament, TournamentUpdatePayload>({
      query: ({ id, ...body }) => ({ url: `/tournaments/${id}`, method: "PUT", body }),
      invalidatesTags: (_res, _err, arg) => [
        { type: "Tournament", id: arg.id },
        { type: "Tournament", id: "LIST" },
      ],
    }),
    deleteTournament: build.mutation<void, string>({
      query: (id) => ({ url: `/tournaments/${id}`, method: "DELETE" }),
      invalidatesTags: (_res, _err, id) => [
        { type: "Tournament", id },
        { type: "Tournament", id: "LIST" },
      ],
    }),
    startTournament: build.mutation<Tournament, string>({
      query: (id) => ({ url: `/tournaments/${id}/start`, method: "POST" }),
      invalidatesTags: (_res, _err, id) => [
        { type: "Tournament", id },
        { type: "Tournament", id: "LIST" },
      ],
    }),
  }),
})

export const {
  useGetTournamentsQuery,
  useGetTournamentQuery,
  useCreateTournamentMutation,
  useUpdateTournamentMutation,
  useDeleteTournamentMutation,
  useStartTournamentMutation,
} = tournamentsApi
